<template>
  <div
    class="upsi-dialog-banner"
    :class="`upsi-dialog-banner--${tone}`"
    data-testid="upsi-dialog-banner"
    role="status"
  >
    <v-icon class="upsi-dialog-banner__icon" aria-hidden="true">{{ icon }}</v-icon>
    <p class="upsi-dialog-banner__message">{{ message }}</p>
  </div>
</template>

<script>
import './UpsiDialogBanner.scss';

/** Info or success banner. First child of each UPSI dialog body. */
export default {
  name: 'UpsiDialogBanner',

  props: {
    tone: {
      type: String,
      default: 'info',
      validator: (value) => ['info', 'success'].includes(value),
    },
    message: {
      type: String,
      default: '',
    },
  },

  computed: {
    icon() {
      return this.tone === 'success' ? 'mdi-check-circle-outline' : 'mdi-information-outline';
    },
  },
};
</script>
